import React, { useEffect, useState } from 'react'
import BookingWidget from '../BookingWidget'
import BookingStep1 from '../Booking/BookingStep1'
import { Provider, useDispatch, useSelector } from 'react-redux'
import store, { persistor } from '../../../js/lib/redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import { setFilters } from '../../../js/lib/redux/slices/booking'

const Fleet = () => {
  const { records } = window.fleetData
  const { filters } = useSelector((state) => state.booking)
  const params = new URLSearchParams(window.location.search)
  const [onLoadFilters, setOnLoadFilters] = useState(false)

  const dispatch = useDispatch()

  //set onload filters by query params
  useEffect(() => {
    const queryString = params.get('type')
    if (queryString) {
      const availableCategoriesIds = records.categories.map((item) => item.code)
      const categroiesIds = queryString
        .split(',')
        .map((item) => Number(item))
        .filter((item) => availableCategoriesIds.includes(item))
      dispatch(setFilters({ category: categroiesIds }))
    } else {
      dispatch(setFilters({}))
    }
    setOnLoadFilters(true)
  }, [])

  //update the url params on filter change
  useEffect(() => {
    if (onLoadFilters) {
      let newUrl = ''
      if (filters.category?.length > 0) {
        params.set('type', filters.category.join(','))
        newUrl = `${window.location.pathname}?${params.toString()}`
      } else {
        params.delete('type')
        newUrl = window.location.pathname
      }
      window.history.replaceState({}, '', newUrl)
    }
  }, [filters, onLoadFilters])

  return (
    <div className="s-fleet">
      <div className="s-fleet__widget">
        <BookingWidget fleet />
      </div>
      <BookingStep1 fleet />
    </div>
  )
}

export default () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Fleet />
    </PersistGate>
  </Provider>
)
